export default "__VITE_ASSET___7SoOS4S__"